import React$1 from 'react';

const NavClose = () => /*#__PURE__*/React$1.createElement("svg", {
  width: "26",
  height: "26",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React$1.createElement("path", {
  fill: "#FF005F",
  fillRule: "nonzero",
  d: "M11.586 13L.491 1.905 1.905.491l11.096 11.095L24.096.49l1.414 1.414L14.415 13 25.51 24.095l-1.414 1.414L13 14.414 1.905 25.51.491 24.095z"
}));

export default NavClose;
